// import Colors from "../../../../theme/colors";

const Styles = {
  container: {
    position: "relative",
  },
  main: {
    position: "absolute",
    top: 38,
    left: 0,
    minHeight: 500,
    backgroundColor: "#fff",
    border: "1px solid rgba(97, 97, 97, 0.5)",
    borderRadius: 8,
    zIndex: 100,
  },
  title: {
    borderRadius: "5px",
    background: "#F5F5F5",
    color: "#616161",
    // padding: "0.3rem 1rem",
    padding: "10px 15px",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
  placeholder: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    backgroundColor: "transparent",
    opacity: 1,
    zIndex: 99,
  },
  hide: {
    visibility: "hidden",
  },
  appliedFilter: {
    display: "flex",
    // border: "1px solid #8C8C8C",
    backgroundColor: "#8C8C8C",
    justifyContent: "space-between",
    borderRadius: "5px",
    padding: "4px 16px",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
};

export default Styles;
